import React, { useMemo } from "react";
import DashboardMetricBar from "./DashboardMetricBar";
import DashboardMrtTable from "./DashboardMrtTable";
import { DASHBOARD_EMPHASIS_CELL_SX } from "./dashboardTableStyles";
import {
  formatAvgHours,
  formatOpenAge,
  getCompletionTone,
  getOverdueTone,
} from "../../utils/dashboardUtils";

const TaskSummaryTable = ({
  rows = [],
  onPersonClick,
  isLoading = false,
  totalItems = 0,
  currentPage = 1,
  pageSize = 10,
  onPaginationChange,
  sorting = [],
  onSortingChange,
}) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "person",
        header: "Person",
        size: 140,
        Cell: ({ row }) => (
          <button
            type="button"
            className="dashboard-person-link"
            onClick={() => {
              if (onPersonClick) onPersonClick(row.original, true);
            }}
          >
            {row.original.person}
          </button>
        ),
      },
      {
        accessorKey: "open",
        header: "Open",
        size: 72,
      },
      {
        accessorKey: "wip",
        header: "WIP",
        size: 72,
      },
      {
        accessorKey: "done",
        header: "Done",
        size: 72,
        muiTableBodyCellProps: { sx: DASHBOARD_EMPHASIS_CELL_SX },
      },
      {
        accessorKey: "overdue",
        header: "Overdue",
        size: 88,
      },
      {
        accessorKey: "completionPct",
        header: "Completion %",
        size: 200,
        Cell: ({ row }) => (
          <DashboardMetricBar
            value={row.original.completionPct}
            tone={getCompletionTone(row.original.completionPct)}
            label={`${row.original.person} completion ${row.original.completionPct}%`}
          />
        ),
      },
      {
        accessorKey: "overduePct",
        header: "Overdue %",
        size: 200,
        Cell: ({ row }) => (
          <DashboardMetricBar
            value={row.original.overduePct}
            tone={getOverdueTone(row.original.overduePct)}
            label={`${row.original.person} overdue ${row.original.overduePct}%`}
          />
        ),
      },
      {
        accessorKey: "avgHrsPerTask",
        header: "Avg Hrs/Task",
        size: 110,
        Cell: ({ row }) => formatAvgHours(row.original.avgHrsPerTask),
      },
      {
        accessorKey: "openAgeAvgDays",
        header: "Open Age (Avg)",
        size: 130,
        muiTableBodyCellProps: { sx: DASHBOARD_EMPHASIS_CELL_SX },
        Cell: ({ row }) => formatOpenAge(row.original.openAgeAvgDays),
      },
    ],
    [onPersonClick]
  );

  return (
    <DashboardMrtTable
      columns={columns}
      data={rows}
      isLoading={isLoading}
      emptyMessage="No task summary data available."
      unitName="people"
      scrollContainer={true}
      enablePagination={true}
      enableServerSide={true}
      rowCount={totalItems}
      state={{ 
        pagination: { pageIndex: Math.max(0, currentPage - 1), pageSize },
        sorting
      }}
      onPaginationChange={(updater) => {
        const prev = { pageIndex: Math.max(0, currentPage - 1), pageSize };
        const next = typeof updater === "function" ? updater(prev) : updater;
        if (onPaginationChange) onPaginationChange({ page: next.pageIndex + 1, limit: next.pageSize });
      }}
      onSortingChange={onSortingChange}
    />
  );
};

export default TaskSummaryTable;

